module.exports = __webpack_public_path__ + "static/media/32-15.fd24ce26.mp3";